import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "./store/hooks";
import { initializeAuthThunk } from "./store/slices/authSlice";
import AppInitializer from "./AppInitializer";
// import { dshopRefreshThunk } from "./stor/dshopAuthSlice";




// function App() {
//   const dispatch = useAppDispatch();
//   const { isInitialized } = useAppSelector((state) => state.auth);

//   useEffect(() => {
//     dispatch(initializeAuthThunk());
//   }, [dispatch]);

//   if (!isInitialized) {
//     return <div>로딩중...</div>;
//   }

//   return <AppRoutes />;
// }

export default function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <BrowserRouter basename={__BASE_PATH__}>
        <AppInitializer>
          <AppRoutes />
        </AppInitializer>
      </BrowserRouter>
    </I18nextProvider>
  );
}
